import theme from 'config/theme';

export default {
  wrapper: {
    display: 'flex',
    height: '100vh',
  },
  toolbar: (drawerWidth) => ({
    background: theme.palette.grays.lightBackgroundGray,
    borderBottom: `1px solid ${theme.palette.grays.gray200}`,
    borderRight: `1px solid ${theme.palette.grays.gray200}`,
    height: theme.customValues.topBarHeight,
    maxHeight: theme.customValues.topBarHeight,
    minHeight: `${theme.customValues.topBarHeight} !important`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 99,
    width: drawerWidth,
  }),
  drawer: (drawerWidth) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    transition: 'width 0.3s',
    display: 'flex',
    flexDirection: 'column',
    width: drawerWidth,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      transition: 'width 0.3s',
      overflow: 'hidden',
    },
  }),
};
